<template>
  <div class="unilever-page">
    <div class="unilever-page__spec">
      <div class="unilever-page__item">
        <label>{{ $tr('vacancy.preferences.special.email') }}</label>
        <input
          name="id-external"
          type="email"
          v-model="vacancyEmail"
        />
      </div>
      <div class="unilever-page__item">
        <label>{{ $tr('vacancy.preferences.special.city') }}</label>
        <input
          name="id-external"
          type="text"
          v-model="vacancyCity"
        />
      </div>
      <div class="unilever-page__item">
        <label>{{ $tr('vacancy.preferences.special.function') }}</label>
        <input
          name="id-external"
          type="text"
          v-model="vacancyFunction"
        />
      </div>
      <div class="unilever-page__item">
        <label>{{ $tr('vacancy.preferences.special.excelLevel') }}</label>
        <input
          name="id-external"
          type="number"
          v-model="vacancyExelLevel"
        />
      </div>
      <div class="unilever-page__item">
        <label>{{ $tr('vacancy.preferences.special.hoursCount') }}</label>
        <input
          name="id-external"
          type="text"
          v-model="vacancyHoursCount"
        />
      </div>
    </div>
    <div class="button-wrapper">
      <vbutton label="common.save" @click="save"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'process-vacancy-preferences-specia',
  beforeMount() {
    this.fetch()
  },
  computed: {
    vacancy () {
      return this.$store.getters['vacancy/one']
    },

    store () {
      return this.$store.state.process.unilever
    },
    data() {
      return this.store.data
    },

    vacancyEmail: {
      get() {
        return this.$store.getters['process/unilever/vacancyEmail']
      },
      set(val) {
        this.change('manager_email', val)
      }
    },
    vacancyCity: {
      get() {
        return this.$store.getters['process/unilever/vacancyCity']
      },
      set(val) {
        this.change('city', val)
      }
    },
    vacancyFunction: {
      get() {
        return this.$store.getters['process/unilever/vacancyFunction']
      },
      set(val) {
        this.change('vacancy_function', val)
      }
    },
    vacancyExelLevel: {
      get() {
        return this.$store.getters['process/unilever/vacancyExelLevel']
      },
      set(val) {
        this.change('excel_level', val)
      }
    },
    vacancyHoursCount: {
      get() {
        return this.$store.getters['process/unilever/vacancyHoursCount']
      },
      set(val) {
        this.change('hours_count', val)
      }
    }
  },
  methods: {
    fetch () {
      this.$store.dispatch('process/unilever/fetch', this.vacancy)
    },
    change (field, value) {
      this.$store.dispatch('process/unilever/update', {field, value})
    },
    save() {
      this.$store.dispatch('process/unilever/save', this.vacancy)
    }
  }
}
</script>

<style lang="scss" scoped>
	.unilever-page {
		&__item {
			display: flex;
			flex-direction: column;
			align-items: start;
			margin-bottom: 20px;
			label {
				margin-bottom: 10px;
			}
		}
	}
</style>